import { render, staticRenderFns } from "./editAdvertising.vue?vue&type=template&id=5025fef2&scoped=true"
import script from "./editAdvertising.vue?vue&type=script&lang=js"
export * from "./editAdvertising.vue?vue&type=script&lang=js"
import style0 from "./editAdvertising.vue?vue&type=style&index=0&id=5025fef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025fef2",
  null
  
)

export default component.exports